import { render, staticRenderFns } from "./comp6.vue?vue&type=template&id=59ed90d2"
import script from "./comp6.vue?vue&type=script&lang=js"
export * from "./comp6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports